﻿import ReduxThunk from 'redux-thunk';
import { createStore, combineReducers, Store, applyMiddleware } from 'redux';
import { EpiContext, UpdateEpiContextActionTypes } from '../../Shared/Scripts/Store/EpiContext/Types';
import { epiContextReducer } from '../../Shared/Scripts/Store/EpiContext/Reducers';
import { stegVisningReducer } from '../../Shared/Scripts/Store/StegVisning/Reducers';
import { EpiAppStateMedSteg } from '../../Shared/Scripts/Store/Types';

import VeilederLutDto from '../Models/VeilederLutDto';

import { valgReducer } from './Valg/Reducers';
import { resultatReducer } from './Resultat/Reducers';
import { lutDataReducer } from './LutData/Reducers';

const rootReducer = combineReducers<VeilederLutAppState>({
    valg: valgReducer,
    epiContext: (
        state: EpiContext<VeilederLutDto> | undefined,
        action: UpdateEpiContextActionTypes<VeilederLutDto>,
    ): EpiContext<VeilederLutDto> => epiContextReducer(state, action),
    stegVisning: stegVisningReducer,
    resultat: resultatReducer,
    lutData: lutDataReducer,
});

export type VeilederLutAppState = EpiAppStateMedSteg<VeilederLutDto> & {
    valg: ReturnType<typeof valgReducer>;
    resultat: ReturnType<typeof resultatReducer>;
    lutData: ReturnType<typeof lutDataReducer>;
};

export default function configureStore(): Store<VeilederLutAppState> {
    return createStore(rootReducer, applyMiddleware(ReduxThunk));
}